<template>
	<div class="d-flex flex-1 h-100 overflow-auto delegation">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_SystemDelegation") }}</v-toolbar-title>
            </v-toolbar>
            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="d-flex m-0 gap-3" style="flex-wrap: wrap; align-items: flex-end;">
                    <div class="p-0" style="flex: 1 0 25%">
                        <v-label class="label_required mb-2">{{ $t("res_Label_FromUser") }}</v-label>
                        <div class="with-absolute-button">
                            <StructureUserSelector :showInternalUsers="true" :showInternalStructures="false" :structure_id="34"
                                :showExternalStructures="false" :excludeSelf="false" :isMultiple="false" :isSubscribedEntitiesEnable="constants.isFullAdmin"
                                :selectedStructureUser="fromUserQuery" @structureUserSelectChanged="selectFromUserQuery">
                            </StructureUserSelector>
                        </div>
                    </div>
                    <div class="p-0" style="flex: 1 0 25%;">
                        <v-label class="label_required mb-2">{{ $t("res_Label_ToUser") }}</v-label>
                        <div class="with-absolute-button">
                            <StructureUserSelector :showInternalUsers="true" :showInternalStructures="false"
                                :showExternalStructures="false" :excludeSelf="false" :isMultiple="false" :isSubscribedEntitiesEnable="constants.isFullAdmin"
                                :selectedStructureUser="toUserQuery" @structureUserSelectChanged="selectToUserQuery">
                            </StructureUserSelector>
                        </div>
                    </div>
                    <div class="p-0" style="flex: 1 0 25%">
                        <label class="label_required mb-2">{{ $t("res_Label_FromDate") }}</label>
                        <v-menu content-class="p-0" v-model="from_date_menu_query" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field class="my-1 shrink dtField" :label="$t('res_Label_SelectDate')" readonly :value="utils.dateFormat(fromDateQuery)" solo v-on="on" 
                                    append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                    <template v-slot:append>
                                        <v-icon v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker :locale="lang" :min="new Date().toISOString()" :allowed-dates="allowedDatesForFromDate" v-model="fromDateQuery" @input="from_date_menu_query = false"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="p-0" style="flex: 1 0 25%; max-width: 25%;">
                        <label class="label_required mb-2">{{ $t("res_Label_ToDate") }}</label>
                        <v-menu content-class="p-0" v-model="to_date_menu_query" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field class="my-1 shrink dtField" :label="$t('res_Label_SelectDate')" readonly :value="utils.dateFormat(toDateQuery)" solo v-on="on" 
                                    append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                    <template v-slot:append>
                                        <v-icon v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker :locale="lang" :min="new Date().toISOString()" :allowed-dates="allowedDatesForFromDate" v-model="toDateQuery" @input="to_date_menu_query = false"></v-date-picker>
                        </v-menu>
                    </div>   
                </div>
                <div class="d-flex align-items-end mt-4" style="width: 100%; justify-content: flex-end;">
                        <v-btn @click="clearQueryForm()" width="100px" color="mx-2 light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                        <v-btn @click="getAllDelegations(true)" width="100px" color="primary">{{ $t("res_ButtonText_Search") }}</v-btn>
                </div>
                <hr>
                <div class="mb-2 d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-end">
                        <Pagination :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                        :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"></Pagination>
                        <v-btn v-if="items.length > 0" class="custom-button" @click="exportToExcelOrPdf(1)" v-tooltip="$t('res_Export_To_Excel')"><v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon></v-btn>
                        <v-btn v-if="items.length > 0" class="custom-button" @click="exportToExcelOrPdf(2)" v-tooltip="$t('res_Export_To_Pdf')"><v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon></v-btn>
                    </div>
                    <div>
                        <v-btn @click="setUpAddSystemDelegationDailog" width="100px" color="primary">{{$t("res_ButtonText_Add")}}</v-btn>
                    </div>
                </div>

                <v-data-table :mobile-breakpoint="0" class="position-relative white flex-1 d-flex overflow-auto" disable-sort
                    :headers="headers" :items="items" loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                    :footer-props="{ 'items-per-page-text': 'Items per page' }" caption=""
                    :class="{ 'result_available': items.length != 0 }" header-fixed fixed-header :hide-default-footer="true"
                    :items-per-page="pagingData.pageSize">
                    <template v-slot:item="row">
                        <tr>
                            <td style="display: none">{{ row.item.id }}</td>
                            <td>{{ row.item.fromStructureName }} / {{ row.item.fromUser }}</td>
                            <td>{{ row.item.structureName }} / {{ row.item.toUser }}</td>
                            <td>{{ utils.dateFormat(row.item.fromDate, 'dd/MM/yy') }}</td>
                            <td>{{ utils.dateFormat(row.item.toDate, 'dd/MM/yy') }}</td>
                            <td>{{ row.item.nodeIds }}</td>
                            <td v-if="row.item.canSign">{{ $t('res_ButtonText_Yes') }}</td>
                            <td v-else>{{ $t('res_ButtonText_No') }}</td> 
                            <td v-if="row.item.allowToSeeOldLetters">{{ $t('res_ButtonText_Yes') }}</td>
                            <td v-else>{{ $t('res_ButtonText_No') }}</td>
                            <td v-if="row.item.canImpersonateSignature && constants.client_version_Id == 'ADNOC'">{{ $t('res_ButtonText_Yes') }}</td>
                            <td v-if="!row.item.canImpersonateSignature && constants.client_version_Id == 'ADNOC'">{{ $t('res_ButtonText_No') }}</td>
                            <td class="text-start">
                                <div class="onhover-display">
                                    <div class="custom-icon-wrapper">
                                        <!--2023: replace the @click event if you do not need confirmation popup -->
                                        <!--@click="getDelegation(row.item.id)" -->
                                        <v-icon @click="confirmGetDelegation(row.item.id)">
                                            custom-icon white-bg edit-icon
                                        </v-icon>
                                    </div>
                                    <div class="custom-icon-wrapper">
                                        <v-icon @click="deleteDelegations(row.item.id)">custom-icon white-bg delete-icon</v-icon>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:no-data>
                        <v-row class="p-5">
                            <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                            <p class="m-0">{{ $t("res_Msgs_AlertNoItemsHere") }}</p>
                        </v-row>
                    </template>
                </v-data-table>
            </div>
        </v-card>
        <ConfirmDialog  
                @actionPerformed="confirmDialogActionPerformed"
                :confirmDialogOptions="this.confirmDialogOptions"
             />

        <v-dialog v-model="addSystemDelegationDailog" content-class="dialog bg-white w-40">
            <v-card>
                <v-toolbar class="bg-white"> 
                    <v-card-title class="p-0">{{ isEditing ? editSystemDelegationLbl: addSystemDelegationLbl }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addSystemDelegationDailog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                    <div class="p-4 flex-grow-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-label class="label_required mb-2">{{ $t("res_Label_FromUser") }}<span> *</span></v-label>
                            <div class="with-absolute-button">
                                <StructureUserSelector :showInternalUsers="true" :showInternalStructures="false"
                                    :showExternalStructures="false" :excludeSelf="false" :isMultiple="false"
                                    :selectedStructureUser="fromUser" @structureUserSelectChanged="selectFromUser">
                                </StructureUserSelector>
                            </div>
                        </div>

                        <div class="mb-3-rem">
                            <v-label class="label_required mb-2">{{ $t("res_Label_ToUser") }}<span> *</span></v-label>
                            <div class="with-absolute-button">
                                <StructureUserSelector :showInternalUsers="true" :showInternalStructures="false"
                                    :showExternalStructures="false" :excludeSelf="false" :isMultiple="false" 
                                    :selectedStructureUser="toUser" @structureUserSelectChanged="selectToUser">
                                </StructureUserSelector>
                            </div>
                        </div>

                        <div class="mb-3-rem">
                            <label class="label_required mb-2">{{ $t("res_Label_FromDate") }}<span> *</span></label>
                            <v-menu content-class="p-0" v-model="from_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class="my-1 shrink dtField" :label="$t('res_Label_SelectDate')" readonly :value="utils.dateFormat(fromDate)" solo v-on="on" 
                                        append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                        <template v-slot:append>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker :locale="lang" v-model="fromDate" @input="from_date_menu = false" :min="new Date().toISOString()"></v-date-picker>
                            </v-menu>
                        </div>

                        <div class="mb-3-rem">
                            <label class="label_required mb-2">{{ $t("res_Label_ToDate") }}<span> *</span></label>
                            <v-menu content-class="p-0" v-model="to_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class="my-1 shrink dtField" :label="$t('res_Label_SelectDate')" readonly :value="utils.dateFormat(toDate)" solo v-on="on" 
                                        append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                        <template v-slot:append>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker :locale="lang" v-model="toDate" @input="to_date_menu = false" :min="new Date().toISOString()"></v-date-picker>
                            </v-menu>
                        </div>

                        <div class="mb-3-rem">
                            <v-label class="label_required mb-2">{{ $t("res_Label_Nodes") }}<span> *</span></v-label>
                            <multi-select class="light-bg add-arrow" v-model="node" label="name" placeholder="Select" track-by="id"
                                open-direction="bottom" :options="nodes" :searchable="false" :internal-search="false"
                                :clear-on-select="false" :close-on-select="false" :options-limit="300" :max-height="600"
                                :show-no-results="false" :hide-selected="false" :multiple="true" ref="multiselect4">
                            </multi-select>
                        </div>

                        <div>
                            <label class="label_required mb-2">{{ $t("res_Label_Privacy") }}<span> *</span></label>
                            <v-select v-model="privacy" :items="constants.privacies" item-text="name" item-value="id" label="" solo return-object></v-select>
                        </div>

                        <div>
                            <v-label></v-label>
                            <v-checkbox v-model="delegationObject.CanSign" :label="allowSignature"></v-checkbox>
                        </div>

                        <!-- <div>
                            <v-label></v-label>
                            <v-checkbox v-model="delegationObject.CanImpersonateSignature" :label="AllowImpersonateSignature"></v-checkbox>
                        </div> -->

                        <div>
                            <v-label></v-label>
                            <v-checkbox v-model="delegationObject.AllowToSeeOldLetters" :label="AllowToSeeOldLetters"></v-checkbox>
                        </div>

                    </div>
                </div> 

                <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="addSystemDelegationDailog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn @click="addOrUpdateDelegation" class="primary flex-1">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    
</template>

<script>
import axios from 'axios';
import router from '@/router/index.js'
import constants from '@/assets/js/constants'
import MultiSelect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import Pagination from '@/components/Pagination.vue'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import $ from 'jquery'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
    name: 'SystemDelegation',
    components: { MultiSelect, Pagination, StructureUserSelector, ConfirmDialog },
    data: function () {
        return { 
            isExport: false,
            exportType: 0,
            addSystemDelegationLbl:  this.$t('res_Msgs_AddSystemDelegation'),
            editSystemDelegationLbl:  this.$t('res_Msgs_EditSystemDelegation'),
            addSystemDelegationDailog: false,
            isEditing: false,
            users: [],
            allowSignature: '',
            AllowImpersonateSignature:'',
            delegationObject: {
                FromUserId: null,
                ToUserId: null,
                FromStructureId: null,
                StructureId: null,
                FromDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                ToDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                NodeIds: "",
                CanSign: false,
                CanImpersonateSignature:false,
                AllowToSeeOldLetters: true,
                privacyId: 0
            },
            queryDelegationObject: {
                FromUserId: null,
                ToUserId: null,
                FromStructureId: null,
                StructureId: null,
                FromDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                ToDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            },
            constants: constants,
            node: [],
            nodeQuery: [],
            fromUser: null,
            fromUserQuery: null,
            toUser: null,
            toUserQuery: null,
            modeText: 'Add',
            delegationId: 0,
            structuresLoading: false,
            loading: false,
            items: [],
            value: null,
            gridHeaders: [],
            dataLoading: false,
            updateDialog: false,
            categories: [{ id: 1, name: this.$t('res_MenuItems_Incoming') }, { id: 2, name: this.$t('res_MenuItems_Outgoing') }, { id: 3, name: this.$t('res_Label_Internal') }],
            nodes: [{ id: 2, name: this.$t('res_TabsName_Inbox') }, { id: 6, name: this.$t('res_TabsName_Sent') },
            { id: 1, name: this.$t('res_TabsName_Draft') }, { id: 9, name: this.$t('res_TabsName_FollowUp') },
            { id: 10, name: this.$t('res_TabsName_CcedInbox') }],
            usersLoading: false,
            options: ['list', 'of', 'options'],
            headers: [
                { text: 'Id', value: 'id', align: ' d-none' },
                { text: this.$t("res_GridHeaders_From"), value: 'fromStructureName', width: '20%' },
                // { text: this.$t("res_GridHeaders_FromUser"), value: 'fromUser', width: '10%' },
                { text: this.$t("res_GridHeaders_To"), value: 'structureName', width: '20%' },
                // { text: this.$t("res_GridHeaders_ToUser"), value: 'toUser', width: '10%' },
                { text: this.$t("res_GridHeaders_FromDate"), value: 'fromDate', width: '7%' },
                { text: this.$t("res_GridHeaders_ToDate"), value: 'toDate', width: '7%' },
                { text: this.$t("res_GridHeaders_Nodes"), value: 'nodeIds', width: '8%' },
                { text: this.$t("res_GridHeaders_CanSign"), value: 'canSign', width: '8%' },
                { text: this.$t("res_Label_SeeOldLetters"), value: 'AllowToSeeOldLetters', width: '8%'},
                { text: this.$t("res_Label_ImpersonateSignature"), value: 'canImpersonateSignature', class: constants.client_version_Id!='ADNOC'?'hidden-header':''  },
                { text: '', value: 'actions', width: '10%', sortable: false },
            ],
            from_date_menu: false,
            from_date_menu_query: false,
            to_date_menu: false,
            to_date_menu_query: false,
            fromDate: window.newDate().toISOString().substr(0, 10),
            fromDateQuery: null,
            formattedFromDate: utils.dateFormat(window.newDate().toISOString().substr(0, 10)),
            toDate: window.newDate().toISOString().substr(0, 10),
            toDateQuery: null,    
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            utils: utils,
            constants: constants,
            confirmDialogOptions: {
                title: '',
                message: '',
                positiveActionButtonText: '',
                negativeActionButtonText: '',
                isPersistent: true,
                visible: false
            },
            delegationIdTemp: 0,
            actionActive: '',
            privacy: null,
            privacyQuery: null,
            AllowToSeeOldLetters: window.translate("res_Label_SeeOldLetters"),
            lang: localStorage.getItem('lang'),
        };
    },
    watch: {
        fromDate() {
            this.formattedFromDate = utils.dateFormat(this.fromDate);
        },
        toDate() {
            
        },
        'delegationObject.CanImpersonateSignature': function (val) {
            if (val) {
                this.delegationObject.CanSign = true
            }
        },
        'delegationObject.CanSign': function (val) {
            if (!val) {
                this.delegationObject.CanImpersonateSignature = false
            }
        }
    },
    methods: {
        allowedDatesForFromDate(val) {
            if(this.toDate == "") return true;
            return val <= this.toDate;
        },
        allowedDatesForToDate(val) {
            if(this.fromDate == "") return true;
            return val >= this.fromDate;
        },
        exportToExcelOrPdf(exportType) {
            this.isExport = true;
            this.exportType = exportType;
            this.getAllDelegations(false);
        },
        setUpAddSystemDelegationDailog()
        {
            this.addSystemDelegationDailog = true;
            this.clearForm();
        },
        clearQueryForm() {
            this.fromUserQuery = null
            this.toUserQuery = null
            this.queryDelegationObject.FromUserId = null;
            this.queryDelegationObject.ToUserId = null;
            this.fromDateQuery = null;
            this.toDateQuery = null;
            this.queryDelegationObject.StructureId = null;
            this.queryDelegationObject.FromStructureId = null;
            this.getAllDelegations(true);
        },
        selectFromUser(item) {
            this.fromUser = item ?? null;
            const parts = item?.id?.toString().split('-') ?? [];
            this.delegationObject.FromUserId = parts[0] ?? null;
            this.delegationObject.FromStructureId = parts[1] ?? null;
        },
        selectFromUserQuery(item) {
            this.fromUserQuery = item ?? null;
            const parts = item?.id?.toString().split('-') ?? [];
            this.queryDelegationObject.FromUserId = parts[0] ?? null;
            this.queryDelegationObject.FromStructureId = parts[1] ?? null;
        },
        selectToUser(item) {
            this.toUser = item ?? null;
            const parts = item?.id?.toString().split('-') ?? [];
            this.delegationObject.ToUserId = parts[0] ?? null;
            this.delegationObject.StructureId = parts[1] ?? null;
        },
        selectToUserQuery(item) {
            this.toUserQuery = item ?? null;
            const parts = item?.id?.toString().split('-') ?? [];
            this.queryDelegationObject.ToUserId = parts[0] ?? null;
            this.queryDelegationObject.StructureId = parts[1] ?? null;
        },
        backToAdminPage(){
            router.push({ name: 'admin' })
        },
        getAllDelegations: function (isResetPaging) {
            if (isResetPaging) {
                this.pagingData.totalCount = 0;
                this.pagingData.pageIndex = 0;
            }
            this.dataLoading = true;
            window.showLoading();

            let queryObj = {
                FromUserId: this.queryDelegationObject.FromUserId ?? 0,
                ToUserId: this.queryDelegationObject.ToUserId ?? 0,
                FromDate: this.fromDateQuery,
                ToDate: this.toDateQuery,
                StructureId: this.queryDelegationObject.StructureId ?? 0,
                FromStructureId: this.queryDelegationObject.FromStructureId ?? 0,
                pageSize: this.pagingData.pageSize,
                pageIndex: this.pagingData.pageIndex,
                CountOnly: 0,
                IsExport: this.isExport,
                ExportType: this.exportType
            };

            console.log(queryObj);

            if(this.isExport)
            {
                var extension = this.exportType == 1 ? '.xlsx' : '.pdf';
                axios({
                    url: constants.baseApiUrl + "Delegation/GetFilteredSystemDelegations",
                    method: 'POST',
                    responseType: 'blob',
                    data: queryObj
                })
                .then((res) => {
                    var blob = new Blob([res.data], { type: "application/octetstream" });
                    const link = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.setAttribute("download", "ExportedData" + `${extension}`);
                    a.setAttribute("href", link);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                })
                .catch((err) => window.hideLoading())
                .finally(() => window.hideLoading())
                this.isExport = false;
                this.exportType = 0;
            }
            else 
            {
                axios
                .post(
                    constants.baseApiUrl +
                    "Delegation/GetFilteredSystemDelegations", queryObj)
                .then((res) => {
                    this.items = res.data;
                    this.dataLoading = false;
                    this.items.forEach(element => {
                        if(element.nodeIds != null)
                        {
                            let delegationNodes = '';
                            let node_array = element.nodeIds.split(',')
                            node_array.forEach((element, index) => {
                                let nodeObject = this.nodes.find((obj) => obj.id == element) 
                                if (index == 0)
                                    {delegationNodes += nodeObject.name}
                                else
                                    {delegationNodes += ', ' + nodeObject.name} 
                            });
                            element.nodeIds = delegationNodes;
                        }
                    });

                    axios.post(constants.baseApiUrl + "Delegation/GetFilteredSystemDelegations", {...queryObj, CountOnly: 1})
                        .then((res) => {
                            if (res.data[0].numberOfRows != 0) {
                                this.pagingData.totalCount = parseInt(res.data[0].numberOfRows);
                            }
                        })
                        .catch((err) => console.warn(err));
                })
                .catch((err) => console.warn(err))
                .finally(() => window.hideLoading());
            }
        },
        deleteDelegations: function (Id) {
            window.showInformation(this.$t("res_Msgs_Confirmation"), this.$t("res_Msgs_DelegateDeleteConfirmation"), () => {
                axios.post(constants.baseApiUrl + 'Delegation/SystemDelegationDelete?delegationId=' + Id)
                    .then((res) => {
                        window.showAlert("res_Msgs_DelegateDeletion", 'success');
                        this.getAllDelegations();
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => this.loading = false)

            }, () => { })
        },
        confirmDialogActionPerformed (result){
            if(result && result.confirmed) {
                if (this.actionActive == 'edit') {
                    this.delegationId = this.delegationIdTemp;
                    this.getDelegation(this.delegationId);
                } else if (this.actionActive == 'clear') {
                    this.clearForm();
                }
            } else if(this.actionActive == 'edit') {
                this.delegationIdTemp = 0;
            }
            this.confirmDialogOptions.visible = false;
        },
        confirmGetDelegation(id){
            if (this.delegationId > 0 && this.delegationId != id) {
                this.delegationIdTemp = id;
                this.actionActive = 'edit';
                this.confirmDialogOptions.message = this.$t('res_Msg_ConfirmationModifyChanges')
                this.confirmDialogOptions.visible = true;
            } else {
                this.getDelegation(id);
            }
        },
        getDelegation: function (Id) {
            this.modeText = 'Update';
            this.delegationId = Id;
            axios.get(constants.baseApiUrl + "Delegation/GetByDelegationId?delegationId=" + Id)
                .then(res => {
                    if (res.data != null) {
                        this.setEditValues(res.data);
                    }
                })
                .catch(err => console.warn(err))
        },
        setEditValues: function (item) {
            var fromDate = new Date(item.fromDate);
            var toDate = new Date(item.toDate);
            this.fromDate = new Date(fromDate - (new Date()).getTimezoneOffset() * 60000).toISOString().slice(0, 10);
            this.toDate = new Date(toDate - (new Date()).getTimezoneOffset() * 60000).toISOString().slice(0, 10);
            this.privacy = constants.privacies.find(x=>x.id == item.privacyId)
            //Set Can Sign
            this.delegationObject.CanSign = item.canSign;
            this.delegationObject.AllowToSeeOldLetters = item.allowToSeeOldLetters;
            this.delegationObject.CanImpersonateSignature = item.canImpersonateSignature;
            //Setting Node
            this.node = [];

            var node_array = item.nodeIds.split(',');
            node_array.forEach(element => {
                var nodeObject = this.nodes.find((obj) => obj.id == element);
                this.node.push(nodeObject)
            });

            //Setting From User
            this.fromUsers = []
            let fromUserObj = {
                id: item.fromUserId + '-' + item.fromStructureId,
                name: item.fromUser
            }
            this.fromUsers.push(fromUserObj);
            this.fromUser = { id: item.fromUserId, name: item.fromUser };
            this.delegationObject.FromStructureId = item.fromStructureId
            this.delegationObject.FromUserId = item.fromUserId

            //Setting To User
            this.toUsers = []
            let toUserObj = {
                id: item.toUserId + '-' + item.structureId,
                name: item.toUser
            }
            this.toUsers.push(toUserObj);
            this.toUser = { id: item.toUserId, name: item.toUser };
            this.delegationObject.StructureId = item.structureId
            this.delegationObject.ToUserId = item.toUserId
            this.isEditing = true;
            this.addSystemDelegationDailog = true;
        },
        confirmClearForm(){
            if (this.delegationId > 0) {
                this.actionActive = 'clear';
                this.confirmDialogOptions.message = this.$t('res_Msg_ConfirmationModifyChanges')
                this.confirmDialogOptions.visible = true;
            } else {
                this.clearForm();
            }
        },
        clearForm: function () {
            let today = new Date();
            let sevenDaysLater = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);

            this.modeText = 'Add';
            this.delegationObject.NodeIds = '';
            this.delegationObject.FromUserId = null;
            this.delegationObject.ToUserId = null;
            this.delegationObject.StructureId = null;
            this.delegationObject.FromStructureId = null;
            this.fromDate = today.toISOString().slice(0, 10);
            this.toDate = sevenDaysLater.toISOString().slice(0, 10);
            this.delegationObject.CanSign = false
            this.delegationObject.AllowToSeeOldLetters = true
            this.delegationObject.CanImpersonateSignature = false  
            this.delegationId = 0;
            this.delegationIdTemp = 0;
            // this.structures = [];
            this.fromUsers = [];
            this.toUsers = [];
            this.privacy = null;
            this.node = [],
                this.fromUser = null,
                this.toUser = null
            this.structure = { id: 0, isUser: false, name: '' }
            this.isEditing = false;
        },
        addOrUpdateDelegation: function () {
            var allNodes = this.node.filter(element => element != null).map(element => element.id).join(',');

            this.delegationObject.NodeIds = allNodes;

            if (this.modeText == 'Add')
                this.addDelegation()
            else
                this.updateDelegation()
        },
        addDelegation: function () {
            if (!this.delegationObject.FromUserId || !this.delegationObject.ToUserId
                || !this.delegationObject.NodeIds
                || !this.delegationObject.StructureId || !this.delegationObject.FromStructureId) {
                window.showAlert("res_Msgs_FillRequired", 'warning')
            }
            else if (!this.privacy || !this.privacy.id) {
                window.showAlert("res_Msgs_fillPrivacy", "warning")
            }
            else if (new Date(this.fromDate) > new Date(this.toDate)) {
                window.showAlert("res_Msgs_DelegationDatesValidation", "warning")
            }
            else if (this.delegationObject.FromUserId == this.delegationObject.ToUserId) {
                window.showAlert('res_Msgs_SameUserCantBeDelegated', 'warning')
            }
            else {
                let myobj = this.delegationObject;
                myobj.FromDate = this.fromDate;
                myobj.ToDate = this.toDate;
                myobj.privacyId = this.privacy.id

                axios.post(constants.baseApiUrl + 'Delegation/SystemDelegationInsert', this.delegationObject)
                    .then(res => {
                        if (res.data == 1) {
                            window.showAlert('res_Msgs_UserExist', 'warning')
                        }
                        else if (res.data == 2) {
                            window.showAlert('res_Msgs_IncorrectDuration', 'warning')
                        }
                        else if (res.data == 3) {
                            window.showAlert('res_Msgs_SameCategoryAssignationValidation', 'warning')
                        }
                        else if (this.delegationObject.FromUserId == this.delegationObject.ToUserId) {
                            window.showAlert('res_Msgs_SameUserCantBeDelegated', 'warning')
                        }
                        else {
                            window.showAlert("res_Msgs_DelegateAddition", 'success')
                            this.getAllDelegations()
                            this.addSystemDelegationDailog = false
                            this.clearForm()
                        }
                    })
                    .catch(err => console.warn(err))
            }
        },
        updateDelegation: function () {
            if (!this.delegationObject.FromUserId || !this.delegationObject.ToUserId
                || !this.delegationObject.NodeIds
                || !this.delegationObject.StructureId || !this.delegationObject.FromStructureId) {
                window.showAlert("res_Msgs_FillRequired", 'warning')
            }
            else if (!this.privacy || !this.privacy.id) {
                window.showAlert("res_Msgs_fillPrivacy", "warning")
            }
            else if (new Date(this.fromDate) > new Date(this.toDate)) {
                window.showAlert("res_Msgs_DelegationDatesValidation", "warning")
            }
            else if (this.delegationObject.FromUserId == this.delegationObject.ToUserId) {
                window.showAlert('res_Msgs_SameUserCantBeDelegated', 'warning')
            }
            else {
                let myobj = this.delegationObject;
                myobj.Id = this.delegationId;
                myobj.FromDate = this.fromDate;
                myobj.ToDate = this.toDate;
                myobj.privacyId = this.privacy.id
                myobj.AllowToSeeOldLetters = this.delegationObject.AllowToSeeOldLetters

                axios.post(constants.baseApiUrl + 'Delegation/SystemDelegationUpdate', myobj)
                    .then(res => {
                        if (res.data == 1) {
                            window.showAlert('res_Msgs_UserDelegatedAlready', 'warning')
                        }
                        else if (res.data == 2) {
                            window.showAlert('res_Msgs_IncorrectDuration', 'warning')
                        }
                        else if (res.data == 3) {
                            window.showAlert('res_Msgs_SomeCategoryAltreadySelected', 'warning')
                        }
                        else {
                            window.showAlert("res_Msgs_DelegationUpdation", 'success')
                            this.getAllDelegations()
                            this.addSystemDelegationDailog = false
                            this.clearForm()
                        }
                    })
                    .catch(err => console.warn(err))
            }
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        openMultiSelectCtrl(id) {
            if (id === 1) this.$refs.multiselect1.activate()
            else if (id === 2) this.$refs.multiselect2.activate()
            else if (id === 3) this.$refs.multiselect3.activate()
            else if (id === 4) this.$refs.multiselect4.activate()
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;

            this.getAllDelegations();
        }
    },
    mounted: function () {
        $(".v-data-footer__pagination").insertAfter($(".v-data-footer__icons-before"));
        this.allowSignature = this.$t("res_Label_AllowSignature");
        this.AllowImpersonateSignature = window.translate("res_Label_AllowImpersonateSignature")

        this.clearForm()
        this.getAllDelegations()
    },
}
</script>

<style>
.dtField .v-input__slot {
    height: 40px !important;
}
.hidden-header { display: none; }
</style>